import {
    FETCHING_WORKSPACE_REPORT_SUMMARY, FETCHING_WORKSPACE_REPORT_SUMMARY_SUCCEDED, FETCHING_WORKSPACE_REPORT_SUMMARY_FAILED,
    FETCHING_WORKSPACE_SESSION_ANALYTICS, FETCHING_WORKSPACE_SESSION_ANALYTICS_SUCCEDED, FETCHING_WORKSPACE_SESSION_ANALYTICS_FAILED,
    FETCHING_WORKSPACE_STORYBOARD_REPORTS, FETCHING_WORKSPACE_STORYBOARD_REPORTS_SUCCEDED, FETCHING_WORKSPACE_STORYBOARD_REPORTS_FAILED,
    FETCHING_WORKSPACE_LEAD_REPORTS,FETCHING_WORKSPACE_LEAD_REPORTS_FAILED,FETCHING_WORKSPACE_LEAD_REPORTS_SUCCEDED,FETCHING_WORKSPACE_ASSET_ANALYTICS,
    FETCHING_WORKSPACE_ASSET_ANALYTICS_SUCCEDED,FETCHING_WORKSPACE_ASSET_ANALYTICS_FAILED,FETCHING_STORYBOARD_REPORTS_FOR_DOWNLOAD_FAILED,
    FETCHING_STORYBOARD_REPORTS_FOR_DOWNLOAD,FETCHING_STORYBOARD_REPORTS_FOR_DOWNLOAD_SUCCEEDED,INVALIDATE_STORYBOARD_REPORTS_DOWNLOAD_DATA,
    FETCHING_SESSION_ANALYTICS_FOR_DOWNLOAD,FETCHING_SESSION_ANALYTICS_FOR_DOWNLOAD_SUCCEEDED,FETCHING_SESSION_ANALYTICS_FOR_DOWNLOAD_FAILED,
    FETCHING_LEAD_ANALYTICS_FOR_DOWNLOAD,FETCHING_LEAD_ANALYTICS_FOR_DOWNLOAD_SUCCEEDED,FETCHING_LEAD_ANALYTICS_FOR_DOWNLOAD_FAILED,
    FETCHING_ASSET_ANALYTICS_FOR_DOWNLOAD,FETCHING_ASSET_ANALYTICS_FOR_DOWNLOAD_SUCCEEDED,FETCHING_ASSET_ANALYTICS_FOR_DOWNLOAD_FAILED,
    INVALIDATE_SESSION_ANALYTICS_DOWNLOAD_DATA,INVALIDATE_LEAD_ANALYTICS_DOWNLOAD_DATA,INVALIDATE_ASSET_ANALYTICS_DOWNLOAD_DATA,
    INVALID_WORKSPACE_REPORTS
} from 'constants/actionTypes';

import { call, put, takeEvery } from 'redux-saga/effects';
import axios from 'axios';
import { createAction } from 'redux-actions';
import LockService from 'services/lock.service';
import buildUrl from 'build-url';
import _ from 'lodash';

const apiUrl = process.env.REACT_APP_CLEVERSTORY_API_URL;
const WORKSPACE_REPORTS_BASE_URL = `${apiUrl}/api/1.0/workspace/reports`

/**
 * fetch workspace Report
*/
export const fetchingWorkspaceReportSummary = createAction(FETCHING_WORKSPACE_REPORT_SUMMARY, (editorSession, request) => {
    return {
        editorSession: editorSession,
        request: request
    };
});

const fetchingWorkspaceReportSummarySucceeded = createAction(FETCHING_WORKSPACE_REPORT_SUMMARY_SUCCEDED, (response) => {
    return response;
});

const fetchingWorkspaceReportSummaryFailed = createAction(FETCHING_WORKSPACE_REPORT_SUMMARY_FAILED, (error) => {
    return error;
});

function* fetchingWorkspaceReportSummarySaga(action) {
    const { reference } = action.payload;
    const headers = {
        'CS-ENTITY-LOCK-TOKEN': LockService.getLock(reference),
    }

    let url = buildUrl(WORKSPACE_REPORTS_BASE_URL, {
        path: '/summary',
    });

    const fetchingWorkspaceReportSummaryAPI = (request) => {
        return axios.get(url, {
            headers: headers,
        }).then(response => response.data);
    }

    try {
        const response = yield call(fetchingWorkspaceReportSummaryAPI);
        if (response) {
            yield put(fetchingWorkspaceReportSummarySucceeded(response));
        }
    } catch (error) {
        yield put(fetchingWorkspaceReportSummaryFailed(error));
    }
}

/**
 * fetch workspace Storyboard Reports
*/
export const fetchingWorkspaceStoryboardReports = createAction(FETCHING_WORKSPACE_STORYBOARD_REPORTS, (request, page, limit) => {
    return {
        request: request,
        page: page,
        limit: limit
    };
});

export const fetchingWorkspaceStoryboardReportsSucceded = createAction(FETCHING_WORKSPACE_STORYBOARD_REPORTS_SUCCEDED, (response) => {
    return response;
});

export const fetchingWorkspaceStoryboardReportsFailed = createAction(FETCHING_WORKSPACE_STORYBOARD_REPORTS_FAILED, (error) => {
    return {
        error: error
    };
});

function* fetchingWorkspaceStoryboardReportsSaga(action) {
    const { request, page, limit } = action.payload;

    let url = buildUrl(WORKSPACE_REPORTS_BASE_URL, {
        path: `/best-performing?page=${page}&limit=${limit}`
    });

    const fetchingWorkspaceStoryboardReportsAPI = () => {
        return axios.post(url, request).then(response => response.data);
    }

    try {
        const response = yield call(fetchingWorkspaceStoryboardReportsAPI);
        if (response) {
            yield put(fetchingWorkspaceStoryboardReportsSucceded(response));
        }
    } catch (error) {
        yield put(fetchingWorkspaceStoryboardReportsFailed(error));
    }
}

/**
 * fetch workspace session analytics Report
*/
export const fetchingWorkspaceSessionAnalyics = createAction(FETCHING_WORKSPACE_SESSION_ANALYTICS, (request, page, limit) => {
    return {
        request: request,
        page: page,
        limit: limit
    };
});

export const fetchingWorkspaceSessionAnalyicsSucceded = createAction(FETCHING_WORKSPACE_SESSION_ANALYTICS_SUCCEDED, (response) => {
    return response;
});

export const fetchingWorkspaceSessionAnalyicsFailed = createAction(FETCHING_WORKSPACE_SESSION_ANALYTICS_FAILED, (error) => {
    return {
        error: error
    };
});

function* fetchingWorkspaceSessionAnalyticsSaga(action) {
    const { request, page, limit } = action.payload;

    let url = buildUrl(WORKSPACE_REPORTS_BASE_URL, {
        path: `/session?page=${page}&limit=${limit}`
    });

    const fetchingWorkspaceSessionAnalyticsAPI = () => {
        return axios.post(url, request).then(response => response.data);
    }
    try {
        const response = yield call(fetchingWorkspaceSessionAnalyticsAPI);
        if (response) {
            yield put(fetchingWorkspaceSessionAnalyicsSucceded(response));
        }
    } catch (error) {
        yield put(fetchingWorkspaceSessionAnalyicsFailed(error));
    }
}

/**
 * fetch workspace lead analytics
*/

export const fetchingWorkspaceLeadReports = createAction(FETCHING_WORKSPACE_LEAD_REPORTS, (request, page, limit) => {
    return {
        request: request,
        page: page,
        limit: limit
    };
});

export const fetchingWorkspaceLeadReportsSucceded = createAction(FETCHING_WORKSPACE_LEAD_REPORTS_SUCCEDED, (response) => {
    return response;
});

export const fetchingWorkspaceLeadReportsFailed = createAction(FETCHING_WORKSPACE_LEAD_REPORTS_FAILED, (error) => {
    return {
        error: error
    };
});

function* fetchingWorkspaceLeadReportsSaga(action) {
    const { request, page, limit } = action.payload;

    let url = buildUrl(WORKSPACE_REPORTS_BASE_URL, {
        path: `/metrics/leads?page=${page}&limit=${limit}`
    });

    const fetchingWorkspaceLeadReportsAPI = () => {
        return axios.post(url, request).then(response => response.data);
    }

    try {
        const response = yield call(fetchingWorkspaceLeadReportsAPI);
        if (response) {
            yield put(fetchingWorkspaceLeadReportsSucceded(response));
        }
    } catch (error) {
        yield put(fetchingWorkspaceLeadReportsFailed(error));
    }
}

/**
 * fetch workspace asset analytics
*/

export const fetchingWorkspaceAssetAnalytics = createAction(FETCHING_WORKSPACE_ASSET_ANALYTICS, (request, page, limit) => {
    return {
        request: request,
        page: page,
        limit: limit
    };
});

export const fetchingWorkspaceAssetAnalyticsSucceded = createAction(FETCHING_WORKSPACE_ASSET_ANALYTICS_SUCCEDED, (response) => {
    return response;
});

export const fetchingWorkspaceAssetAnalyticsFailed = createAction(FETCHING_WORKSPACE_ASSET_ANALYTICS_FAILED, (error) => {
    return {
        error: error
    };
});

function* fetchingWorkspaceAssetAnalyticsSaga(action) {
    const { request, page, limit } = action.payload;

    let url = buildUrl(WORKSPACE_REPORTS_BASE_URL, {
        path: `/assets?page=${page}&limit=${limit}`
    });

    const fetchingWorkspaceAssetAnalyticsAPI = () => {
        return axios.post(url, request).then(response => response.data);
    }

    try {
        const response = yield call(fetchingWorkspaceAssetAnalyticsAPI);
        if (response) {
            yield put(fetchingWorkspaceAssetAnalyticsSucceded(response));
        }
    } catch (error) {
        yield put(fetchingWorkspaceAssetAnalyticsFailed(error));
    }
}

export const invalidateWorkspaceReports = createAction(INVALID_WORKSPACE_REPORTS);

// Download Reports 

/**
 Fetch storyboard report For Download
 */

export const fetchStoryboardReportsForDownload = createAction(FETCHING_STORYBOARD_REPORTS_FOR_DOWNLOAD, (request, page, limit) => {
    return {
        request: request,
        page: page,
        limit: limit
    }
});

const fetchStoryboardReportsForDownloadSucceeded = createAction(FETCHING_STORYBOARD_REPORTS_FOR_DOWNLOAD_SUCCEEDED, (response) => {
    return {
        response: response
    }
});

const fetchStoryboardReportsForDownloadFailed = createAction(FETCHING_STORYBOARD_REPORTS_FOR_DOWNLOAD_FAILED, (error) => {
    return {
        error: error
    }
});

function* downloadStoryBoardReportSaga(action) {
    const { request, page, limit } = action.payload;

    try {
        let url = buildUrl(WORKSPACE_REPORTS_BASE_URL, {
            path: `/best-performing?page=${page}&limit=${limit}`
        });

        const fetchingStoryboardReportsAPI = () => {
            return axios.post(url, request).then(response => response.data);
        }

        var response = yield call(fetchingStoryboardReportsAPI);

        if (response) {
            const { records, ...pagination } = response;
            const hasMoreItems = _.get(pagination, 'currentPage') < _.get(pagination, 'totalPages') - 1;
            var nextPage = page + 1;

            if (hasMoreItems) {
                yield put(fetchStoryboardReportsForDownload(request, nextPage, limit));
            }

            yield put(fetchStoryboardReportsForDownloadSucceeded(response));
        }
    } catch (error) {
        yield put(fetchStoryboardReportsForDownloadFailed(error));
    }
}

/**
 Fetch session analytics For Download
 */

export const fetchSessionAnalyticsForDownload = createAction(FETCHING_SESSION_ANALYTICS_FOR_DOWNLOAD, (request, page, limit) => {
    return {
        request: request,
        page: page,
        limit: limit
    }
});

const fetchSessionAnalyticsForDownloadSucceeded = createAction(FETCHING_SESSION_ANALYTICS_FOR_DOWNLOAD_SUCCEEDED, (response) => {
    return {
        response: response
    }
});

const fetchSessionAnalyticsForDownloadFailed = createAction(FETCHING_SESSION_ANALYTICS_FOR_DOWNLOAD_FAILED, (error) => {
    return {
        error: error
    }
});

function* downloadSessionAnalyticsSaga(action) {
    const { request, page, limit } = action.payload;

    try {
        let url = buildUrl(WORKSPACE_REPORTS_BASE_URL, {
            path: `/session?page=${page}&limit=${limit}`
        });

        const fetchingSessionAnalyticsAPI = () => {
            return axios.post(url, request).then(response => response.data);
        }

        var response = yield call(fetchingSessionAnalyticsAPI);

        if (response) {
            const { records, ...pagination } = response;
            const hasMoreItems = _.get(pagination, 'currentPage') < _.get(pagination, 'totalPages') - 1;
            var nextPage = page + 1;

            if (hasMoreItems) {
                yield put(fetchSessionAnalyticsForDownload(request, nextPage, limit));
            }

            yield put(fetchSessionAnalyticsForDownloadSucceeded(response));
        }
    } catch (error) {
        yield put(fetchSessionAnalyticsForDownloadFailed(error));
    }
}

export const fetchLeadReportsForDownload = createAction(FETCHING_LEAD_ANALYTICS_FOR_DOWNLOAD, (request, page, limit) => {
    return {
        request: request,
        page: page,
        limit: limit
    }
});

const fetchLeadReportsForDownloadSucceeded = createAction(FETCHING_LEAD_ANALYTICS_FOR_DOWNLOAD_SUCCEEDED, (response) => {
    return {
        response: response
    }
});

const fetchLeadReportsForDownloadFailed = createAction(FETCHING_LEAD_ANALYTICS_FOR_DOWNLOAD_FAILED, (error) => {
    return {
        error: error
    }
});

function* downloadLeadAnalyticsSaga(action) {
    const { request, page, limit } = action.payload;

    try {
        let url = buildUrl(WORKSPACE_REPORTS_BASE_URL, {
            path: `/metrics/leads?page=${page}&limit=${limit}`
        });

        const fetchingLeadReportsAPI = () => {
            return axios.post(url, request).then(response => response.data);
        }

        var response = yield call(fetchingLeadReportsAPI);

        if (response) {
            const { records, ...pagination } = response;
            const hasMoreItems = _.get(pagination, 'currentPage') < _.get(pagination, 'totalPages') - 1;
            var nextPage = page + 1;

            if (hasMoreItems) {
                yield put(fetchLeadReportsForDownload(request, nextPage, limit));
            }

            yield put(fetchLeadReportsForDownloadSucceeded(response));
        }
    } catch (error) {
        yield put(fetchLeadReportsForDownloadFailed(error));
    }
}

export const fetchAssetsAnalyticsForDownload = createAction(FETCHING_ASSET_ANALYTICS_FOR_DOWNLOAD, (request, page, limit) => {
    return {
        request: request,
        page: page,
        limit: limit
    }
});

const fetchAssetsAnalyticsForDownloadSucceeded = createAction(FETCHING_ASSET_ANALYTICS_FOR_DOWNLOAD_SUCCEEDED, (response) => {
    return {
        response: response
    }
});

const fetchAssetsAnalyticsForDownloadFailed = createAction(FETCHING_ASSET_ANALYTICS_FOR_DOWNLOAD_FAILED, (error) => {
    return {
        error: error
    }
});

function* downloadAssetAnalyticsSaga(action) {
    const { request, page, limit } = action.payload;

    try {
        let url = buildUrl(WORKSPACE_REPORTS_BASE_URL, {
            path: `/assets?page=${page}&limit=${limit}`
        });

        const fetchingAssetAnalyticsAPI = () => {
            return axios.post(url, request).then(response => response.data);
        }

        var response = yield call(fetchingAssetAnalyticsAPI);

        if (response) {
            const { records, ...pagination } = response;
            const hasMoreItems = _.get(pagination, 'currentPage') < _.get(pagination, 'totalPages') - 1;
            var nextPage = page + 1;

            if (hasMoreItems) {
                yield put(fetchAssetsAnalyticsForDownload(request, nextPage, limit));
            }

            yield put(fetchAssetsAnalyticsForDownloadSucceeded(response));
        }
    } catch (error) {
        yield put(fetchAssetsAnalyticsForDownloadFailed(error));
    }
}

export const invalidateStoryboardReportDownloadData = createAction(INVALIDATE_STORYBOARD_REPORTS_DOWNLOAD_DATA);
export const invalidateSessionAnalyticsDownloadData = createAction(INVALIDATE_SESSION_ANALYTICS_DOWNLOAD_DATA);
export const invalidateLeadAnalyticsDownloadData = createAction(INVALIDATE_LEAD_ANALYTICS_DOWNLOAD_DATA);
export const invalidateAssetAnalyticsDownloadData = createAction(INVALIDATE_ASSET_ANALYTICS_DOWNLOAD_DATA);

export default function* workspaceReportSaga() {
    yield takeEvery(FETCHING_WORKSPACE_REPORT_SUMMARY, fetchingWorkspaceReportSummarySaga)
    yield takeEvery(FETCHING_WORKSPACE_SESSION_ANALYTICS, fetchingWorkspaceSessionAnalyticsSaga)
    yield takeEvery(FETCHING_WORKSPACE_LEAD_REPORTS, fetchingWorkspaceLeadReportsSaga)
    yield takeEvery(FETCHING_WORKSPACE_STORYBOARD_REPORTS, fetchingWorkspaceStoryboardReportsSaga)
    yield takeEvery(FETCHING_WORKSPACE_ASSET_ANALYTICS, fetchingWorkspaceAssetAnalyticsSaga)
    yield takeEvery(FETCHING_STORYBOARD_REPORTS_FOR_DOWNLOAD, downloadStoryBoardReportSaga)
    yield takeEvery(FETCHING_SESSION_ANALYTICS_FOR_DOWNLOAD, downloadSessionAnalyticsSaga)
    yield takeEvery(FETCHING_LEAD_ANALYTICS_FOR_DOWNLOAD, downloadLeadAnalyticsSaga)
    yield takeEvery(FETCHING_ASSET_ANALYTICS_FOR_DOWNLOAD, downloadAssetAnalyticsSaga)
}